import angular from 'angular';
import { STATES } from '../../../constants/';
import { OffersConfig } from './offers.config';

export const PromotionsStepModule = angular
  .module(STATES.STEP_PROMOTIONS, [])
  .config(OffersConfig);
